module.exports = __webpack_public_path__ + "img/employers-anytime.5ef00e14.jpg";